import { Breadcrumbs as MuiBreadcrumbs, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

const RootBreadcrumbs = styled(MuiBreadcrumbs)(({ theme }) => ({
  '& .MuiBreadcrumbs-separator': {
    color: theme.palette.grey[300],
    fontSize: '0.75rem',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
}));

const Crumb = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[400],
  fontSize: '0.75rem',
}));

const CrumbLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '0.75rem',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

const Version = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[400],
  fontSize: '0.75rem',
  '& .edit-icon': {
    marginLeft: 10,
    opacity: 0,
    transition: 'ease opacity 1s',
  },
  '&:hover .edit-icon': {
    opacity: 1,
  },
}));

const CrumbIcon = styled('span')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export { Crumb, CrumbIcon, CrumbLink, RootBreadcrumbs, Version };
